export default __webpack_public_path__ + "static/media/ats.ea032d48.jpeg";